import { Status } from '../../status';
import { DataFlowModuleDisplay } from './DataFlowModuleDisplay';

export class DataFlowModule {
  public Deleted: boolean;

  public Display: DataFlowModuleDisplay;

  public ID: string;

  public Settings: any;

  public Status: Status;

  public Text: string;
}
